import React from "react"
import Typography from "aldoo-ra/Typography"

const LanguageBadgesGrid = ({ badges }) => {
  return (
    <div className="w-full md:max-w-[900px] lg:max-w-w2_l xl:max-w-w1_xl 
    grid gap-2 grid-cols-2 md:grid-cols-3 xl:grid-cols-5 justify-self-center mx-auto">
      {badges.map((badge, index) => (
        <div
          key={index}
          className="h-[50px] md:h-[76px] lg:h-[96px] flex flex-row gap-2 md:gap-[16px] items-center justify-start bg-orange_lt hover:bg-gradient_language_badges rounded-[16px] md:rounded-[24px] px-4 md:pl-[30px]"
        >
          <div className="w-[30px] md:w-[47px] h-[30px] md:h-[47px] flex-shrink-0">
            <img src={badge.icon} className="w-full h-full" alt={badge.language} />
          </div>

          <Typography 
            variant="h4_light"
            className="overflow-hidden text-ellipsis"  
          >
            {badge.language}
          </Typography>
        </div>
      ))}
    </div>
  )
}

export default LanguageBadgesGrid
